import { createFrontendModule } from '@backstage/frontend-plugin-api';
import { deploymentsEntityCard } from './DeploymentsEntityCard';
import { deploymentsEntityContent } from './DeploymentsEntityContent';
import { argocdEntityContent } from './ArgocdEntityContent';
import { catalogIndexPage } from './CatalogIndexPage';
import { entityPageHeader } from './EntityPageHeader';

export const catalogModule = createFrontendModule({
  pluginId: 'catalog',
  extensions: [
    deploymentsEntityCard,
    deploymentsEntityContent,
    argocdEntityContent,
    catalogIndexPage,
    entityPageHeader,
  ],
});
